import {Component, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {GAService} from "../../root/ga/ga.service";
import {SearchPhoneService} from "./searchphone.service";
import {SidebarService} from "../../root/sidebar/sidebar.service";
import {ContractService} from "../../core/contract.service";

@Component({
    selector: 'contact',
    templateUrl: './contact.component.html',
    providers: [SearchPhoneService]
})
export class ContactComponent implements OnInit {

    companyOid: number;
    selectedCountryPhoneLocalExterior: string;
    commercialExecutiveEmail: string;

    constructor(private route: ActivatedRoute, private gaService: GAService, private searchPhoneService: SearchPhoneService, private sidebarService: SidebarService, private ngZone: NgZone, private contractService: ContractService) {
        this.sidebarService.sidebar = "contact";
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.companyOid = params['id'];

            this.ngZone.run(() => {
                this.searchPhoneService.getEmergencyPhone(this.companyOid).subscribe(response => {
                        this.selectedCountryPhoneLocalExterior = response;
                    }
                );

                this.contractService.get(this.companyOid).subscribe(response => {
                        this.commercialExecutiveEmail = response[0].businessExecutiveContact;
                    }
                );
            })
        })

    }

    notifyGA(mail){
        this.gaService.notify("Autos_contacto", "Mail_To", [mail]);
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/contact/contact.component.ts